'use client';

import React from 'react';

import { LoginBtn, ProfileBtn, ProfileChipSkeleton } from './components';
import { useLogin } from './hooks';

export default function ProfileChip(): React.ReactNode {
  const { loading, userData } = useLogin();

  if (loading) return <ProfileChipSkeleton />;

  if (userData?.accessToken) return <ProfileBtn userName={userData?.name} />;

  return <LoginBtn />;
}
